module.exports = __webpack_public_path__ + "static/ud_to_do_list-811bca511d6cdc9577f8fb9475cfd88b.svg";